import { FC } from 'react';
import { ButtonBase } from '../../../../../ButtonBase/ButtonBase';
import { TwoFaSectionTitle } from '../../../shared/TwoFaSectionTitle';
import { TwoFaSectionDescription } from '../../../shared/TwoFaSectionDescription';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { TwoFaSectionButtonsWrapper } from '../../../shared/TwoFaSectionButtonsWrapper';
import { useModalDrawerContext } from '../../../../../ModalDrawerContext/ModalDrawerContext';

const FinishedSummaryPage: FC = () => {
  const { closeAll } = useModalDrawerContext();

  const { t } = useClientTranslation();

  return (
    <>
      <TwoFaSectionTitle title={`${t('2fa_success_subtitle')}`} />
      <TwoFaSectionDescription textContent={t('2fa_success_body')} />
      <TwoFaSectionButtonsWrapper>
        <ButtonBase onClick={closeAll} visual="primary" size="medium">
          {t('done')}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { FinishedSummaryPage };
